import normalizeComponent from "./component-library92.mjs";
const _sfc_main = {};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("svg", { attrs: { "viewBox": "0 0 137 137", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, [_c("path", { attrs: { "d": "M68.5 0.5C30.9446 0.5 0.5 30.9446 0.5 68.5C0.5 106.055 30.9446 136.5 68.5 136.5C106.055 136.5 136.5 106.055 136.5 68.5C136.5 30.9446 106.055 0.5 68.5 0.5ZM68.5 19.9286C78.3819 19.9286 87.5716 22.9109 95.2483 27.9987L27.9987 95.2483C22.9109 87.5691 19.9286 78.3794 19.9286 68.5C19.9286 41.7177 41.7177 19.9286 68.5 19.9286ZM68.5 117.071C58.6109 117.071 49.4139 114.087 41.7323 108.992L108.989 41.7347C114.084 49.4163 117.071 58.6133 117.071 68.5024C117.071 95.2823 95.2823 117.071 68.5 117.071Z", "fill": "#B2B2B2" } })]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null,
  null,
  null
);
const NoAccessIcon = __component__.exports;
export {
  NoAccessIcon as default
};
